const aspectRatios: Record<Content.Properties.AspectRatio, number> = {
  fourByThree: 3 / 4,
  nineBySixteen: 16 / 9,
  oneByOne: 1,
  sixteenByNine: 9 / 16,
  threeByFour: 4 / 3,
  threeByOne: 1 / 3,
};

const SIZE_MULTIPLIER = 1.5;

export const formatImageUrl = (
  url: string,
  parameters: {
    aspectRatio?: Content.Properties.AspectRatio | null;
    focalPoint?: FocalPoint | null;
    height?: number;
    width: number;
  },
) => {
  if (!url) return '';

  if (url.startsWith('/images/') || url.includes('umbraco')) {
    return url;
  }

  let formattedUrl = `${url}`;

  if (parameters.width) {
    const hasQuery = formattedUrl.includes('?');

    formattedUrl += `${hasQuery ? '&' : '?'}width=${Math.ceil(parameters.width * SIZE_MULTIPLIER)}`;
  }

  if (parameters.height) {
    const hasQuery = formattedUrl.includes('?');

    formattedUrl += `${hasQuery ? '&' : '?'}height=${Math.ceil(parameters.height * SIZE_MULTIPLIER)}`;
  } else if (parameters.aspectRatio) {
    const hasQuery = formattedUrl.includes('?');

    formattedUrl += `${hasQuery ? '&' : '?'}height=${Math.ceil(parameters.width * aspectRatios[parameters.aspectRatio] * SIZE_MULTIPLIER)}`;
  }

  if (parameters.focalPoint) {
    const hasQuery = formattedUrl.includes('?');

    const left = parameters.focalPoint?.leftPercentage ?? 50;
    const top = parameters.focalPoint?.topPercentage ?? 50;
    const anchorPoint = `${(left / 100).toFixed(2)},${(top / 100).toFixed(SIZE_MULTIPLIER)}`;

    formattedUrl += `${hasQuery ? '&' : '?'}rxy=${anchorPoint}`;
  }

  return formattedUrl;
};
